import axios from 'axios';

import { getConfig } from '../common/config';

const UPSELL_MIDDLEWARE_PATH = 'api/upsell-middleware';

const config = getConfig();

export interface QualtricsRequestBody {
  advance: boolean;
  embeddedData: any;
  response: boolean;
}

export interface QualtricsResponse {
  result: {
    eventId: string;
  };
  meta: {
    httpStatus: string;
    requestId: string;
  };
}

export const postQualtricsDataService = async (
  body: QualtricsRequestBody,
  token: string
): Promise<QualtricsResponse> => {
  try {
    const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
    const url = `${config.BASE_URL}${UPSELL_MIDDLEWARE_PATH}/trigger-qualtrics`;
    const { data } = await axios.post(`${url}`, body, {
      headers,
    });

    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};

export const postQualtricsData = async (body: QualtricsRequestBody, token: string): Promise<QualtricsResponse> => {
  return postQualtricsDataService(body, token);
};
